export enum EmployeeRole {
    MANAGING_DIRECTOR = "MANAGING_DIRECTOR",
    PAYMENT_APPROVER = "PAYMENT_APPROVER",
    PROJECT_MANAGER = "PROJECT_MANAGER",
    ACCOUNTANT = "ACCOUNTANT",
    PAYMENT_AUTHORIZER = "PAYMENT_AUTHORIZER",
    EMPLOYEE = "EMPLOYEE",
    SYSTEM_ADMIN = "SYSTEM_ADMIN"
}

export interface EmployeeProject {
    employeeId: number;
    projectId: number;
    projectName: string;
    projectDescription: string;
    companyName: string;
    startDate: string;
    dueDate: string;
    status: string;
}

export enum EmployeeSex {
    MALE = 'MALE',
    FEMALE = 'FEMALE',
}

export interface Employee {
    id?: number;
    firstName: string;
    middleName: string;
    lastName: string;
    email: string;
    phone: string;
    employmentNumber: string;
    designationId: number;
    address: string;
    active: boolean;
    hasUserAccount?: boolean;
    roles?: EmployeeRole[];
    digitalSignature?: string;
    sex?: EmployeeSex;
}